// extracted by mini-css-extract-plugin
export default {"dark":"Table_dark__QORrJ","light":"Table_light__wIQGk","table":"Table_table__dK8Cd"};